import actionTypes from '../constants/action-types';
import generateId from '../helpers/generate-id';

const addFolder = ({ folderName, parentFolderId = null, locale }) => ({
  type: actionTypes.ADD_FOLDER,
  payload: {
    folderId: generateId(),
    folderName,
    parentFolderId,
    locale,
  },
});

export default addFolder;
